<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
  import 'weui';
  export default {   
    name: 'App',
    created: function () {
    },
    methods: {

    }
  }
</script>

<style>
  html, body {
    position: relative;
    height: 100%;
    width: 100%;
    margin: 0;
    padding: 0;
    overflow-x: hidden;
    background-color: rgba(242, 242, 242, 1);
  }
</style>



// WEBPACK FOOTER //
// src/App.vue